import { render, staticRenderFns } from "./EdInputFile.vue?vue&type=template&id=01d24abc&"
import script from "./EdInputFile.vue?vue&type=script&lang=js&"
export * from "./EdInputFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports